<template>
    <div ref="mainHigh" class="mianLogin">
        <div class="logoTop">
            <div class="imgs">
               <img src="./img/logo_notext.png" alt="">
            </div>
            <h3>高企助手</h3>
        </div>
        <div class="input-groud">
            <input v-model="form.phone" type="tel"  maxlength="11" placeholder="请输入联系电话">
            <input v-model="form.watc" type="text" placeholder="请输入验证码">
            <div class="captchaCode">
<!--              <canvas @click="generateCaptcha" ref="captchaCanvas" width="120" height="30"></canvas>-->
              <a-button
                style="background:rgba(0, 88, 180);border:none;cursor: pointer;color: #fff;position: relative;z-index: 2;"
                ref="codeBtnWordBtn"
                @click="getPhoneCode()"
              >
                {{ codeBtnWord }}
              </a-button>
              <div class="codeBtnWordMark" ref="codeBtnWordMarkid"></div>
            </div>
        </div>
        <a-button class="subtn" size="large" type="primary"  @click="submit()">登录</a-button>
        <span class="subtn" style="margin-top:-.5rem;font-size:1rem;background:none" @click="goMore('/webHighEnterpriseEvaluation/register') ">立即注册</span>
        <div class="er-code">
            <img src="@/assets/webHighEnterpriseEvaluation/log-bottom.png" />
        </div>
    </div>
  </template>

  <script>
  import {ls} from "@/utils/util";
  import {basicsEvaluateUsers} from "@/api/webHighEnterpriseEvaluation";
  import {phoneCommon} from "@/api/finance";
  import {notification} from "ant-design-vue";
  import {jwtToken} from "@/api/materializePolicy";
  import axios from "axios";
  export default {

    data () {
        return {
            captcha:null,
          codeBtnWord: '获取短信验证码',
            form:{
                phone:null,
                watc:null
            }
        }
    },
    mounted() {
        if(ls.get('wxLoginPhone')){
            this.form.phone = ls.get('wxLoginPhone')
        }
      this.$refs.mainHigh.style.height = window.innerHeight+'px'
      this.generateCaptcha();//验证码
    },
    methods: {
      getPhoneCode() {
        let that=this
        const phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!phoneReg.test(this.form.phone)) {
          alert('请输入正确的手机号码！')
          return
        } else {
          this.postAction({
            url: phoneCommon.sealSMS,
            params: {
              phone: this.form.phone
            }
          }).then((res) => {
            console.log(res,"rrr");
            if (res.code === '0') {
              this.waitTime = (res.msg * 60) + 1
              // this.waitTime = 61

              console.log(this.waitTime,44444444444)
              this.waitTime--;
              this.$refs.codeBtnWordMarkid.style.zIndex = -1;
              this.codeBtnWord = `${this.waitTime}s 后获取`;
              let timer = setInterval(() => {
                if (this.waitTime > 1) {
                  this.waitTime--;
                  this.codeBtnWord = `${this.waitTime}s 后获取`;
                } else {
                  clearInterval(timer);
                  this.codeBtnWord = "获取短信验证码";
                  this.$refs.codeBtnWordMarkid.style.zIndex = -1
                  this.waitTime = 61;
                }
              }, 1000);
              notification.success({
                message: '验证码发送成功，请查看手机短信',
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft: `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            }else if (res.code === '1') {
              notification.success({
                message: '验证码发送失败，请稍后重新发送',
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft:  `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            } else if (res.code === '2') {
              notification.success({
                message: res.msg,
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft: `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            } else if (res.code === '3') {
              notification.success({
                message: res.msg,
                placement: 'topLeft',
                style: {
                  width: '400px',
                  fontWeight: '600',
                  marginLeft:  `-${that.screenWidth/2-200}px`,
                  marginTop: `${20}%`,
                }
              });
            }
          })
        }
      },
        getcheckUser(phone) {
           /* this.getAction({
                url: basicsEvaluateUsers.checkUser,
                params:{
                    contactPhone:phone
                }
            }
            ).then((res) => {
              if(res.id){
                this.$ls.set("wxLoginPhone", res.contactPhone)
                this.goMore('/webHighEnterpriseEvaluation?bottom_nav_ico=1')
              }else{
                alert('用户未注册！')
              }
            })*/
          this.getAxios('get', basicsEvaluateUsers.checkUser, { contactPhone:phone
          }, (res) => {
            console.log(res,'res')
            if(res.data.data.id){
              this.$ls.set("wxLoginPhone", res.data.data.contactPhone)
              this.goMore('/webHighEnterpriseEvaluation?bottom_nav_ico=1')
            }else{
              alert('用户未注册！')
            }
          })
        },
      getAxios(method, url, params, fun) {
        axios({
          method: method,
          headers: {
            AuthenticationPhone: ls.get('jwtphone'),
            AuthenticationJwt: ls.get('jwtMain')
          },
          url: url,
          params: params
        }).then(res => {
          console.log(res,'resgetAxios')
          if (res) {
            fun(res)
          }
        }).catch(() => {
          this.visible = false
          notification.warning({
            message: '登录过期',
            style: {
              width: '400px',
              fontWeight: '600',
              marginLeft: `${-200}%`,
              marginTop: `${20}%`,
            }
          });
          this.modalShowType = null
          setTimeout(() => {
            this.visible = true
          }, 50);
        })
      },
        submit(){
            if(this.form.phone&&this.form.watc){
                const phoneReg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if(!phoneReg.test(this.form.phone)){
                    alert('请输入正确的手机号码！')
                }else{

                  this.postAction({
                    url: phoneCommon.sealSMSCheck,
                    params: {
                      code: this.form.watc,
                      phone: this.form.phone
                    }
                  }).then((res) => {
                    if (res) {
                      ls.set('jwtphone', this.form.phone);
                      this.getAction({
                        url: jwtToken.phoneGetJwt,
                        params: {
                          phone: this.form.phone
                        }
                      }).then((res) => {
                        if (res) {
                          ls.set('jwtMain', res)
                          setTimeout(() => {
                            this.getcheckUser(this.form.phone)
                          }, 50);
                        }
                      })
                    } else {
                      notification.error({
                        message: '验证码有误，请输入正确验证码',
                        duration: 10,
                        style: {
                          width: '400px',
                          fontWeight: '600',
                          marginTop: `${10}%`,
                        },
                      });
                    }
                  })

                   /* if(this.form.watc.toLowerCase()==this.captcha.toLowerCase()){
                        this.getcheckUser(this.form.phone)
                    }else{
                        this.generateCaptcha();//验证码
                        alert('请输入正确的验证码！')
                    }*/
                }
            }else{
                alert('请正确填写手机号和验证码！')
            }
        },
        //路由跳转
        goMore(url, str) {
            if(str){
                this.$router.push({ path: url, query: { id: str } })
            }else{
                this.$router.push(url)
            }
        },
        //验证码部分start
        generateCaptcha() {
            const canvas = this.$refs.captchaCanvas;
            const ctx = canvas.getContext('2d');

            // 验证码背景色\
            ctx.fillStyle = 'rgb(220, 255, 255)'
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // 验证码字符集
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            // 生成4位随机验证码
            let captcha = '';
            for (let i = 0; i < 4; i++) {
            const char = characters[Math.floor(Math.random() * characters.length)];

            // 随机生成字符的颜色
            const color = `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)})`;
            ctx.fillStyle = color;
            ctx.font = 'bold 36px Arial';
            ctx.fillText(char, 30 * i, 28);

            captcha += char;
            }

            // 将生成的验证码存储起来或发送给后端进行验证
            this.captcha = captcha
            console.log('生成的验证码:', captcha);

        }
        //验证码部分end
    }
  };
  </script>
  <style lang="less" scoped>
  .er-code{
      img{
          width:90vw;
      }
  }
  .codeBtnWordMark {
    width: 100%;
    height: 40px;
    //background: rgba(0, 88, 180);
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }
  .mianLogin{
    font-family: '微软雅黑';
    width:100%;
    background: url(./img/bg.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    font-size: 1.1rem;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .logoTop{
        width:90vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom:2rem;
        font-weight: bold;
        .imgs{
            border-radius: 8rem;
            width:8rem;
            height:8rem;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom:.5rem;
        }
    }
    .input-groud{
        display: flex;
        flex-direction: column;
        width:90vw;
        height:8rem;
        padding: 0 1rem;
        background: #fff;
        position: relative;
        border-radius: .4rem;
        .captchaCode{
            position:absolute;
            right:1rem;
            bottom:.8rem;
            z-index: 999;
        }
        input{
            flex:1;
            font-size: 1rem;
            color:#3d3d3d;
            padding:.5rem;
            &:focus{
                border-style: none;
                outline: none;
            }
            border:0;
            height:3rem
        }
    }
    .subtn{
        width:90vw;
        margin-top:2rem;
        padding:.8rem 0 2.4rem;
        font-size: 1.1rem;
        background: #1c4ff7;
        text-align: center;
    }
  }
  </style>
